// Interpretação pura de eventos de TaskHistory — nunca mostra JSON bruto.
// Eventos conhecidos viram um resumo amigável traduzido; qualquer evento
// desconhecido (ou metadata em formato inesperado) cai num texto genérico
// traduzido, sem quebrar a tela.

const KNOWN_EVENT_TYPES = [
  "created",
  "updated",
  "started",
  "completed",
  "transferred",
  "canceled",
  "contact_notified"
];

const CHANGED_FIELD_KEYS = {
  title: "tasks.history.fields.title",
  description: "tasks.history.fields.description",
  priority: "tasks.history.fields.priority",
  dueDate: "tasks.history.fields.dueDate"
};

// Retorna a CHAVE de tradução (não o texto) e os parâmetros necessários —
// quem chama (componente) resolve i18n.t, mantendo esta função sem
// depender de nenhuma instância de i18n para ser testável isoladamente.
export const describeHistoryEvent = event => {
  const eventType = event?.eventType;
  const metadata = event && typeof event.metadata === "object" && event.metadata !== null ? event.metadata : {};

  if (!KNOWN_EVENT_TYPES.includes(eventType)) {
    return { key: "tasks.history.events.unknown", params: {} };
  }

  switch (eventType) {
    case "created":
      return { key: "tasks.history.events.created", params: {} };

    case "started":
      return { key: "tasks.history.events.started", params: {} };

    case "completed":
      return { key: "tasks.history.events.completed", params: {} };

    case "canceled":
      return { key: "tasks.history.events.canceled", params: {} };

    case "transferred":
      // Aprovado mostrar só uma descrição genérica — nunca IDs de usuário,
      // e sem consulta extra para resolver nomes.
      return { key: "tasks.history.events.transferred", params: {} };

    case "contact_notified":
      return { key: "tasks.history.events.contactNotified", params: {} };

    case "updated": {
      const changes =
        metadata.changes && typeof metadata.changes === "object" ? metadata.changes : {};
      const changedFieldKeys = Object.keys(changes)
        .filter(field => CHANGED_FIELD_KEYS[field])
        .map(field => CHANGED_FIELD_KEYS[field]);

      if (changedFieldKeys.length === 0) {
        return { key: "tasks.history.events.updatedGeneric", params: {} };
      }

      return { key: "tasks.history.events.updated", params: { fieldKeys: changedFieldKeys } };
    }

    default:
      return { key: "tasks.history.events.unknown", params: {} };
  }
};
